var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.029,
    height: 40.919,
    viewBox: "0 0 41.029 40.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 39.728,
    height: 31.45,
    rx: 4.038,
    ry: 4.038,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.363,
    y: 36.558,
    width: 25.54,
    height: 3.711,
    rx: 1.21,
    ry: 1.21,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.529,
    y: 32.1,
    width: 13.206,
    height: 4.458,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.379,4.688c0-2.221-1.817-4.038-4.038-4.038H4.688C2.467.65.65,2.467.65,4.688v.707h39.729v-.707Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 33.175,
    cy: 3.178,
    r: 0.592,
    fill: "#73307a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.228,
    cy: 3.178,
    r: 0.592,
    fill: "#73307a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.282,
    cy: 3.178,
    r: 0.592,
    fill: "#73307a"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 8.59,
    y1: 16.89,
    x2: 8.59,
    y2: 12.711,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.59,
    y1: 24.893,
    x2: 8.59,
    y2: 20.713,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.733,
    y1: 15.371,
    x2: 18.733,
    y2: 22.022,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.082,
    y1: 18.696,
    x2: 18.566,
    y2: 18.696,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.049,
    y1: 19.029,
    x2: 29.374,
    y2: 19.029,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.307,
    y1: 23.685,
    x2: 25.882,
    y2: 23.685,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.374,11.048h-1.257c-1.234,0-2.234,1-2.234,2.234v11.161c0,1.234,1,2.234,2.234,2.234h1.341",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 21.476,
    y1: 9.053,
    x2: 17.236,
    y2: 9.053,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.908,
    y1: 9.053,
    x2: 14.41,
    y2: 9.053,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 21.476,
    y1: 28.34,
    x2: 17.236,
    y2: 28.34,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.908,
    y1: 28.34,
    x2: 14.41,
    y2: 28.34,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.431,
    y: 25.015,
    width: 6.651,
    height: 3.325,
    rx: 0.834,
    ry: 0.834,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.457,
    y: 25.015,
    width: 6.651,
    height: 3.325,
    rx: 0.834,
    ry: 0.834,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.457,
    y: 17.283,
    width: 6.651,
    height: 3.325,
    rx: 0.834,
    ry: 0.834,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.457,
    y: 9.635,
    width: 6.651,
    height: 3.325,
    rx: 0.834,
    ry: 0.834,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.573,
    y: 12.046,
    width: 6.651,
    height: 3.325,
    rx: 0.834,
    ry: 0.834,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.573,
    y: 22.188,
    width: 6.651,
    height: 3.325,
    rx: 0.834,
    ry: 0.834,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.431,
    y: 17.117,
    width: 6.651,
    height: 3.325,
    rx: 0.834,
    ry: 0.834,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.59,
    cy: 10.05,
    r: 2.66,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.f694ab5e.svg";
export { ForwardRef as ReactComponent };